// 申請状況照会のラベル
export const LABELS = {
  EMPTY: "　",
  PAYMENT_ACCOUNTS_LIST: "入金口座一覧",

  APPLICANT_COMPANY_NAME: "申請事業者名",
  IPID: "IPID",
  REFERENCE_GROUP_NAME: "参照グループ名",
  PAYMENT_TARGET_COMPANY_NAME: "入金先事業者名",
  MERCHANTS_NAME: "加盟店名",

  OTHER: "　その他",
  NUM: "件",
  NO: "NO",
} as const;

// 一覧の1ページ当たりの件数
export const LIST_PAGE_SIZE = 10;
